import React from "react";

const Java_matches = () => {
  return (
    <div>
      <h1>Java matches</h1>
      <p>This page provides explanations, examples, and common use-cases for Java matches in Java.</p>
    </div>
  );
};

export default Java_matches;
